import register from '../util/init';

import {cartInit, checkoutForm} from '../shoptools/checkout'

function artisanCart (container) {
  cartInit(container)

  container.querySelectorAll('.selection-forms form').forEach((formEl) => {
    formEl.querySelectorAll('.form-field select').forEach((selectEl) => {
      selectEl.addEventListener('change', (e) => {
        formEl.submit()
      })
    })
  })
}
register('shoptools-cart-page', artisanCart)

function artisanCheckout (container) {
  const formEl = container.querySelector('.checkout-form')

  if (formEl) checkoutForm(formEl)
}
register('shoptools-checkout-page', artisanCheckout)



// WEBPACK FOOTER //
// ./assets/j/src/checkout.js